import React, { useEffect } from 'react';
import PropTypes from "prop-types";
import { formatDate } from "../includes/utils";

export function CsfPivotalFournisseurRecognitionDetailConfirmation({ trainingConfirmation, trainingUfcInfo, allMatiereInfo }) {

  const langcode = document.documentElement.lang;

  return (
    <div className="d-none print-wrapper print-confirmation">
      <img src="/themes/custom/tink/dist/assets/print-black-logo.png" alt="Chambre de la sécurité financière" />
      <h1 className="text-center">
        {window.Drupal.t('fournisseur.recognition.detail.history.confirm')}
      </h1>
      <div className="confirmation-intro">
        <p>{window.Drupal.t('fournisseur.confirmation.intro')}</p>
      </div>
      <div className="confirmation-info">
        <table>
          <caption>
            {langcode === 'fr' ?
              (trainingConfirmation.Name_French !== null ?
                trainingConfirmation.Name_French
                : trainingConfirmation.Name_English
              ) :
              (trainingConfirmation.Name_English !== null ?
                trainingConfirmation.Name_English
                : trainingConfirmation.Name_French
              )
            }
          </caption>
          <tr>
            <td width="55%">{window.Drupal.t('fournisseur.confirmation.info.validity')}</td>
            {trainingConfirmation.Start_Date && (
              <td className="confirmation-bold">{formatDate(trainingConfirmation.Start_Date)}</td>
            )}
          </tr>
          <tr>
            <td width="55%">{window.Drupal.t('fournisseur.confirmation.info.enddate')}</td>
            <td className="confirmation-bold">
              {trainingConfirmation.Start_Date && (
                window.Drupal.t('broker.compliance.titlePage.currentPeriod.start') + ' ' + formatDate(trainingConfirmation.Start_Date) + ' '
              )}
              {trainingConfirmation.End_Date && (
                window.Drupal.t('broker.compliance.titlePage.currentPeriod.stopword') + ' ' + formatDate(trainingConfirmation.End_Date)
              )}
            </td>
          </tr>
          <tr>
            <td width="55%">{window.Drupal.t('fournisseur.confirmation.info.number')}</td>
            {trainingConfirmation.Recognition_Code && (
              <td className="confirmation-bold">#{trainingConfirmation.Recognition_Code}</td>
            )}
          </tr>
          <tr>
            <td width="55%">{window.Drupal.t('fournisseur.confirmation.info.total.ufc')}</td>
            <td className="confirmation-bold">{trainingUfcInfo.GSFT_UFC_Total}</td>
          </tr>
          <tr>
            <td width="55%">{window.Drupal.t('fournisseur.confirmation.info.ufc.notion')}</td>
            <td className="confirmation-bold">
              <ul>
                {
                  trainingUfcInfo.Cycle_UFC__Secondary && allMatiereInfo.length > 0 &&
                  trainingUfcInfo.Cycle_UFC__Secondary.map((val) => {
                    const matchedObject = allMatiereInfo.find(obj => obj.REDU_Subject_Id === val.Subject_Id);
                    return (
                      <li key={val.Subject_Id}>
                        {val.Asked_UFC} {window.Drupal.t('in')} {langcode === 'fr' ? matchedObject?.Name_French : matchedObject?.Name_English}
                      </li>
                    );
                  })
                }
              </ul>
            </td>
          </tr>
        </table>
      </div>
      <div className="confirmation-footnote">
        <p>
          {window.Drupal.t('fournisseur.confirmation.footnote.text1')}<br />
          {window.Drupal.t('fournisseur.confirmation.footnote.text2')}
        </p>
        <table>
          <tr>
            <td width="50">
              <img src="/themes/custom/tink/dist/assets/print-checkmark.png" alt="" />
            </td>
            <td>{window.Drupal.t('fournisseur.confirmation.footnote.item1')}</td>
          </tr>
          <tr>
            <td width="50">
              <img src="/themes/custom/tink/dist/assets/print-checkmark.png" alt="" />
            </td>
            <td>{window.Drupal.t('fournisseur.confirmation.footnote.item2')}</td>
          </tr>
          <tr>
            <td width="50">
              <img src="/themes/custom/tink/dist/assets/print-checkmark.png" alt="" />
            </td>
            <td>
              {window.Drupal.t('fournisseur.confirmation.footnote.item3')}
              <ul>
                <li>{window.Drupal.t('fournisseur.confirmation.footnote.subitem1')}</li>
                <li>{window.Drupal.t('fournisseur.confirmation.footnote.subitem2')}</li>
                <li>{window.Drupal.t('fournisseur.confirmation.footnote.subitem3')}</li>
              </ul>
            </td>
          </tr>
        </table>
        <div dangerouslySetInnerHTML={{ __html: window.Drupal.t('fournisseur.confirmation.footnote.contact') }}></div>
        <p className="thank-you-text"><b>{window.Drupal.t('fournisseur.confirmation.footnote.thank')}</b></p>
      </div>
    </div>
  );
}

CsfPivotalFournisseurRecognitionDetailConfirmation.propTypes = {
  trainingConfirmation: PropTypes.object.isRequired,
  trainingUfcInfo: PropTypes.object.isRequired,
  allMatiereInfo: PropTypes.array.isRequired
};
